function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { classNames } from '../../../../utilities/css.js';
import { ConditionalRender, ConditionalWrapper } from '../../../../utilities/components.js';
import { isInterface } from '../../../../utilities/is-interface.js';
import { isReactElement } from '../../../../utilities/is-react-element.js';
import styles from './Header.scss.js';
import { Breadcrumbs } from '../../../Breadcrumbs/Breadcrumbs.js';
import { Title } from './components/Title/Title.js';
import { hasGroupsWithActions, ActionMenu } from '../../../ActionMenu/ActionMenu.js';
import { FilterActionsProvider } from '../../../FilterActionsProvider/FilterActionsProvider.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { useMediaQuery } from '../../../../utilities/media-query/hooks.js';
import { Box } from '../../../Box/Box.js';
import { Pagination } from '../../../Pagination/Pagination.js';
import { Text } from '../../../Text/Text.js';
import { InlineStack } from '../../../InlineStack/InlineStack.js';
import { buttonFrom } from '../../../Button/utils.js';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
var SHORT_TITLE = 20;
var REALLY_SHORT_TITLE = 8;
var LONG_TITLE = 34;
function Header(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    pageReadyAccessibilityLabel = _ref.pageReadyAccessibilityLabel,
    titleMetadata = _ref.titleMetadata,
    additionalMetadata = _ref.additionalMetadata,
    _ref$titleHidden = _ref.titleHidden,
    titleHidden = _ref$titleHidden === void 0 ? false : _ref$titleHidden,
    primaryAction = _ref.primaryAction,
    pagination = _ref.pagination,
    filterActions = _ref.filterActions,
    backAction = _ref.backAction,
    _ref$secondaryActions = _ref.secondaryActions,
    secondaryActions = _ref$secondaryActions === void 0 ? [] : _ref$secondaryActions,
    _ref$actionGroups = _ref.actionGroups,
    actionGroups = _ref$actionGroups === void 0 ? [] : _ref$actionGroups,
    _ref$compactTitle = _ref.compactTitle,
    compactTitle = _ref$compactTitle === void 0 ? false : _ref$compactTitle,
    onActionRollup = _ref.onActionRollup;
  var i18n = useI18n();
  var _useMediaQuery = useMediaQuery(),
    isNavigationCollapsed = _useMediaQuery.isNavigationCollapsed;
  var isSingleRow = !primaryAction && !pagination && (isInterface(secondaryActions) && !secondaryActions.length || isReactElement(secondaryActions)) && !actionGroups.length;
  var breadcrumbMarkup = backAction ? /*#__PURE__*/React.createElement("div", {
    className: styles.BreadcrumbWrapper
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "100%",
    paddingInlineEnd: "100",
    printHidden: true
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    backAction: backAction
  }))) : null;
  var paginationMarkup = pagination && !isNavigationCollapsed ? /*#__PURE__*/React.createElement("div", {
    className: styles.PaginationWrapper
  }, /*#__PURE__*/React.createElement(Box, {
    printHidden: true
  }, /*#__PURE__*/React.createElement(Pagination, Object.assign({}, pagination, {
    hasPrevious: pagination.hasPrevious,
    hasNext: pagination.hasNext
  })))) : null;
  var pageTitleMarkup = /*#__PURE__*/React.createElement("div", {
    className: styles.TitleWrapper
  }, /*#__PURE__*/React.createElement(Title, {
    title: title,
    subtitle: subtitle,
    titleMetadata: titleMetadata,
    compactTitle: compactTitle
  }));
  var labelForPageReadyAccessibilityLabel = pageReadyAccessibilityLabel || title;
  var pageReadyAccessibilityLabelMarkup = labelForPageReadyAccessibilityLabel ? /*#__PURE__*/React.createElement("div", {
    role: "status"
  }, /*#__PURE__*/React.createElement(Text, {
    visuallyHidden: true,
    as: "p"
  }, i18n.translate('Polaris.Page.Header.pageReadyAccessibilityLabel', {
    title: labelForPageReadyAccessibilityLabel
  }))) : undefined;
  var primaryActionMarkup = primaryAction ? /*#__PURE__*/React.createElement(PrimaryActionMarkup, {
    primaryAction: primaryAction
  }) : null;
  var actionMenuMarkup = null;
  if (isInterface(secondaryActions) && (secondaryActions.length > 0 || hasGroupsWithActions(actionGroups))) {
    actionMenuMarkup = /*#__PURE__*/React.createElement(ActionMenu, {
      actions: secondaryActions,
      groups: actionGroups,
      rollup: isNavigationCollapsed,
      rollupActionsLabel: title ? i18n.translate('Polaris.Page.Header.rollupActionsLabel', {
        title: title
      }) : undefined,
      onActionRollup: onActionRollup
    });
  } else if (isReactElement(secondaryActions)) {
    actionMenuMarkup = /*#__PURE__*/React.createElement(React.Fragment, null, secondaryActions);
  }
  var navigationMarkup = breadcrumbMarkup || paginationMarkup ? /*#__PURE__*/React.createElement(Box, {
    printHidden: true,
    paddingBlockEnd: "100",
    paddingInlineEnd: actionMenuMarkup && isNavigationCollapsed ? '1000' : undefined
  }, /*#__PURE__*/React.createElement(InlineStack, {
    gap: "400",
    align: "space-between",
    blockAlign: "center"
  }, breadcrumbMarkup, paginationMarkup)) : null;
  var additionalMetadataMarkup = additionalMetadata ? /*#__PURE__*/React.createElement("div", {
    className: styles.AdditionalMetaData
  }, /*#__PURE__*/React.createElement(Text, {
    tone: "subdued",
    as: "span",
    variant: "bodySm"
  }, additionalMetadata)) : null;
  var headerClassNames = classNames(isSingleRow && styles.isSingleRow, navigationMarkup && styles.hasNavigation, actionMenuMarkup && styles.hasActionMenu, isNavigationCollapsed && styles.mobileView, !backAction && styles.noBreadcrumbs, title && title.length < LONG_TITLE && styles.mediumTitle, title && title.length > LONG_TITLE && styles.longTitle);
  var _determineLayout = determineLayout({
      actionMenuMarkup: actionMenuMarkup,
      additionalMetadataMarkup: additionalMetadataMarkup,
      breadcrumbMarkup: breadcrumbMarkup,
      isNavigationCollapsed: isNavigationCollapsed,
      pageTitleMarkup: pageTitleMarkup,
      paginationMarkup: paginationMarkup,
      primaryActionMarkup: primaryActionMarkup,
      title: title
    }),
    slot1 = _determineLayout.slot1,
    slot2 = _determineLayout.slot2,
    slot3 = _determineLayout.slot3,
    slot4 = _determineLayout.slot4,
    slot5 = _determineLayout.slot5;
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    paddingBlockStart: {
      xs: '400',
      md: '600'
    },
    paddingBlockEnd: {
      xs: '400',
      md: '600'
    },
    paddingInlineStart: {
      xs: '400',
      sm: '0'
    },
    paddingInlineEnd: {
      xs: '400',
      sm: '0'
    },
    visuallyHidden: titleHidden
  }, pageReadyAccessibilityLabelMarkup, /*#__PURE__*/React.createElement("div", {
    className: headerClassNames
  }, /*#__PURE__*/React.createElement(FilterActionsProvider, {
    filterActions: Boolean(filterActions)
  }, /*#__PURE__*/React.createElement(ConditionalRender, {
    condition: [slot1, slot2, slot3, slot4].some(notNull)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Row
  }, slot1, slot2, /*#__PURE__*/React.createElement(ConditionalRender, {
    condition: [slot3, slot4].some(notNull)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.RightAlign
  }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: [slot3, slot4].every(notNull),
    wrapper: function wrapper(children) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.Actions
      }, children);
    }
  }, slot3, slot4))))), /*#__PURE__*/React.createElement(ConditionalRender, {
    condition: [slot5].some(notNull)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Row
  }, /*#__PURE__*/React.createElement(InlineStack, {
    gap: "400"
  }, slot5))))));
}
function PrimaryActionMarkup(_ref2) {
  var primaryAction = _ref2.primaryAction;
  var _useMediaQuery2 = useMediaQuery(),
    isNavigationCollapsed = _useMediaQuery2.isNavigationCollapsed;
  var actionMarkup;
  if (isInterface(primaryAction)) {
    var isPrimary = primaryAction.primary,
      helpText = primaryAction.helpText;
    var primary = isPrimary === undefined ? true : isPrimary;
    var content = buttonFrom(shouldShowIconOnly(isNavigationCollapsed, primaryAction), {
      variant: primary ? 'primary' : undefined
    });
    actionMarkup = helpText ? /*#__PURE__*/React.createElement(Tooltip, {
      content: helpText
    }, content) : content;
  } else {
    actionMarkup = primaryAction;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.PrimaryActionWrapper
  }, /*#__PURE__*/React.createElement(Box, {
    printHidden: true
  }, actionMarkup));
}
function shouldShowIconOnly(isMobile, action) {
  var content = action.content,
    accessibilityLabel = action.accessibilityLabel,
    icon = action.icon;
  if (icon == null) return _objectSpread(_objectSpread({}, action), {}, {
    icon: undefined
  });
  if (isMobile) {
    accessibilityLabel = accessibilityLabel || content;
    content = undefined;
  } else {
    icon = undefined;
  }
  return _objectSpread(_objectSpread({}, action), {}, {
    content: content,
    accessibilityLabel: accessibilityLabel,
    icon: icon
  });
}
function notNull(value) {
  return value != null;
}
function determineLayout(_ref3) {
  var actionMenuMarkup = _ref3.actionMenuMarkup,
    additionalMetadataMarkup = _ref3.additionalMetadataMarkup,
    breadcrumbMarkup = _ref3.breadcrumbMarkup,
    isNavigationCollapsed = _ref3.isNavigationCollapsed,
    pageTitleMarkup = _ref3.pageTitleMarkup,
    paginationMarkup = _ref3.paginationMarkup,
    primaryActionMarkup = _ref3.primaryActionMarkup,
    title = _ref3.title;
  //    Header Layout
  // |----------------------------------------------------|
  // | slot1 | slot2 |                    | slot3 | slot4 |
  // |----------------------------------------------------|
  // | slot5 |                                            |
  // |----------------------------------------------------|
  //
  var layouts = {
    mobileCompact: {
      slots: {
        slot1: null,
        slot2: pageTitleMarkup,
        slot3: actionMenuMarkup,
        slot4: primaryActionMarkup,
        slot5: additionalMetadataMarkup
      },
      condition: isNavigationCollapsed && breadcrumbMarkup == null && title != null && title.length <= REALLY_SHORT_TITLE
    },
    mobileDefault: {
      slots: {
        slot1: breadcrumbMarkup,
        slot2: pageTitleMarkup,
        slot3: actionMenuMarkup,
        slot4: primaryActionMarkup,
        slot5: additionalMetadataMarkup
      },
      condition: isNavigationCollapsed
    },
    desktopCompact: {
      slots: {
        slot1: breadcrumbMarkup,
        slot2: pageTitleMarkup,
        slot3: actionMenuMarkup,
        slot4: primaryActionMarkup,
        slot5: additionalMetadataMarkup
      },
      condition: !isNavigationCollapsed && paginationMarkup == null && actionMenuMarkup == null && title != null && title.length <= SHORT_TITLE
    },
    desktopDefault: {
      slots: {
        slot1: breadcrumbMarkup,
        slot2: pageTitleMarkup,
        slot3: /*#__PURE__*/React.createElement(React.Fragment, null, actionMenuMarkup, primaryActionMarkup),
        slot4: paginationMarkup,
        slot5: additionalMetadataMarkup
      },
      condition: !isNavigationCollapsed
    }
  };
  var layout = Object.values(layouts).find(function (layout) {
    return layout.condition;
  }) || layouts.desktopDefault;
  return layout.slots;
}
export { Header };